<div class="rx-ag-header__title">{{params.displayName}}</div>
<rx-icon [name]="'info'" class="tooltip-icon"  *ngIf="params?.column?.getUserProvidedColDef()?.headerTooltip" ></rx-icon>
<div class="rx-ag-header__arrow">
  <i class="ag-icon" [ngClass]="sortIcon"></i>
</div>
<div
  class="rx-ag-header__filter-button rx-ag-header__filter-button--visible"
  *ngIf="params.column.getColDef().filter && (params.api.getRowNode('0') || params?.enableMenu)"
  #filterButton
  [ngClass]="{
    'rx-ag-header__filter-button--active': filterActive
  }"
  (click)="onFilterButtonClicked($event)"
>
  <i class="ag-icon ag-icon-filter"></i>
</div>
